"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMaritalStatusTrads = void 0;
exports.EMaritalStatusTrads = {
    celibataire: "Célibataire",
    divorce: "Divorcé(e)",
    marie: "Marié(e)",
    pacse: "Pacsé(e)",
    veuf: "Veuf(ve)",
    union_libre: "Union libre",
};
